import { FC } from "react";
import { FeaturesOverviewLayout } from "@/components/FeaturesOverview";
import { Blocks, BuilderBlock } from "@builder.io/sdk-react";
import { BuilderProps } from "@/types/builder/BuilderProps";
import { BuilderBlockProps } from "@/types";

type FeaturesOverviewCardsBlockProps = {
  featureCards?: {
    cardContent: BuilderBlock[];
    featureContent: BuilderBlock[];
    button?: {
      viewMore: string;
      viewLess: string;
      dlt: string;
      dld: string;
    };
  }[];
} & BuilderProps &
  BuilderBlockProps;

export const FeaturesOverviewCardsBlock: FC<
  FeaturesOverviewCardsBlockProps
> = ({
  featureCards,
  builderBlock,
  builderComponents,
  builderContext,
  builderLinkComponent,
  attributes,
}) => {
  if (!featureCards?.length) {
    return null;
  }

  return (
    <div {...attributes}>
      <FeaturesOverviewLayout
        featureCards={featureCards.map(
          ({ cardContent, featureContent, button }, index) => ({
            cardContent: (
              <Blocks
                key={builderBlock?.id}
                parent={builderBlock?.id}
                registeredComponents={builderComponents}
                context={builderContext}
                path={`featureCards.${index}.cardContent`}
                blocks={cardContent}
                linkComponent={builderLinkComponent}
              />
            ),
            featureContent: (
              <Blocks
                key={builderBlock?.id}
                parent={builderBlock?.id}
                registeredComponents={builderComponents}
                context={builderContext}
                path={`featureCards.${index}.featureContent`}
                blocks={featureContent}
                linkComponent={builderLinkComponent}
              />
            ),
            button: button,
          }),
        )}
      />
    </div>
  );
};
